<lib-dynamic-listing
  [module]="'client-so'"
  [filters]="filterConfigs"
  [columns]="columnConfigs"
  [data]="tableData"
  [actions]="actionConfigs"
  [isLoading]="isLoading"
  [pageIndex]="pageIndex"
  [rowsPerPage]="rowsPerPage"
  [totalCount]="totalCount"
  [totalPages]="totalPages"
  [exportFilename]="exportFilename"
  (filterEvent)="onFilterEvent($event)"
  (actionClicked)="onActionClicked($event)"
  (pageChanged)="onPageChanged($event)"
  (exportCsv)="exportCsv()"
  (exportXlsx)="exportXlsx()"
  (exportPdf)="exportPdf()"
  (columnsSelected)="onColumnsSelected($event)">
</lib-dynamic-listing>
